import { motion } from "framer-motion";
import { fadeUp, viewportOnce } from "../lib/motion";

const VisionTrust = () => (
    <section
        data-testid="vision-trust-panel"
        className="relative border-y border-white/10 bg-ink"
    >
        <div className="mx-auto max-w-[1600px] px-6 py-14 md:px-10 lg:px-16 lg:py-20">
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="flex flex-col gap-8 md:flex-row md:items-start md:justify-between"
            >
                <div className="max-w-3xl">
                    <p className="flex items-center gap-3 font-mono text-[14px] tracking-[0.3em] text-white">
                        <span className="h-1.5 w-1.5 bg-accent" />
                        AI-GENERATED CONCEPT
                    </p>
                    <p
                        data-testid="vision-trust-copy"
                        className="mt-5 text-[16px] leading-relaxed text-mist"
                    >
                        Not a construction drawing, approved architectural
                        documentation, engineering documentation or guarantee
                        of the final built appearance.
                    </p>
                </div>
                <p className="shrink-0 font-mono text-[13px] tracking-[0.22em] text-cad md:text-right">
                    TRUST NOTE — T.01
                    <span className="mt-2 block h-px w-16 bg-accent md:ml-auto" />
                </p>
            </motion.div>
        </div>
    </section>
);

export default VisionTrust;
